export default function ThumbsUpIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <g clipPath="url(#thumbsUpa)">
        <path
          fill="#FFC380"
          d="M8.069 5.98H5.022a.352.352 0 01-.179-.656C6.17 4.54 6.86 3.625 6.951 2.527a.757.757 0 01.756-.68 1.48 1.48 0 011.037.444c.276.28.428.65.428 1.044v.119c0 .96-.284 1.573-.81 2.368a.352.352 0 01-.293.158z"
        />
        <path
          fill="#FFCF99"
          d="M11.802 6.379c0-.609-.495-1.104-1.104-1.104H5.022a.352.352 0 00-.18.05c-.398.235-.8.429-1.123.585-.113.054-.22.106-.316.154a.352.352 0 00-.195.315v4.508c0 .134.075.256.195.316 1.423.711 2.606.797 3.985.797.214 0 .433-.002.657-.004.249-.003.506-.005.775-.005h1.113a1.105 1.105 0 00.95-1.664 1.104 1.104 0 00.376-1.503 1.104 1.104 0 00.24-1.686c.196-.206.303-.474.303-.759z"
        />
        <path
          fill="#29CCB1"
          d="M11.07 3.307h-.752a.352.352 0 010-.704h.751a.352.352 0 110 .704zm-5.26 0h-.752a.352.352 0 010-.704h.752a.352.352 0 010 .704zm1.127-1.952a.352.352 0 01-.305-.176L6.256.53a.352.352 0 01.61-.353l.376.65a.352.352 0 01-.305.53zm2.253 0a.352.352 0 01-.305-.528l.377-.65a.352.352 0 11.61.351l-.376.651a.352.352 0 01-.305.176z"
        />
        <path
          fill="#73C3FF"
          d="M2.405 10.14v1.855H1.7v-1.854a.352.352 0 01.705 0z"
        />
        <path
          fill="#29CCB1"
          d="M11.07 3.307h-.752a.352.352 0 010-.704h.751a.352.352 0 110 .704zm-5.26 0h-.752a.352.352 0 010-.704h.752a.352.352 0 010 .704zm1.127-1.952a.352.352 0 01-.305-.176L6.256.53a.352.352 0 01.61-.353l.376.65a.352.352 0 01-.305.53zm2.253 0a.352.352 0 01-.305-.528l.377-.65a.352.352 0 11.61.351l-.376.651a.352.352 0 01-.305.176z"
        />
        <path
          fill="#73C3FF"
          d="M2.405 10.14v1.855H1.7v-1.854a.352.352 0 01.705 0z"
        />
        <path
          fill="#44A4EC"
          d="M3.556 5.275H.55a.352.352 0 00-.352.353v6.01c0 .196.158.353.352.357h2.255a1.116 1.116 0 001.103-1.108v-5.26a.352.352 0 00-.352-.352z"
        />
        <path
          fill="#73C3FF"
          d="M2.405 10.117v1.878H1.7v-1.878a.352.352 0 01.705 0z"
        />
      </g>
      <defs>
        <clipPath id="thumbsUpa">
          <path
            fill="#fff"
            d="M0 0h12v12H0z"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
